import axios from 'axios';

/**
 * Создаёт экземпляр axios с заданной конфигурацией.
 *
 * @param {string} type - Тип запроса (ключ для выбора URL).
 * @param {Object} param - Объект с параметрами, должен содержать token и ключ type.
 * @returns {AxiosInstance|null}
 */
export function push_api(type, param) {
    try {
        if (!param.hasOwnProperty(type)) {
            throw new Error('not_found_type');
        }

        const url = param[type];

        let headers = {
            'Authorization': 'Bearer ' + param.token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            // 'X-Group-Id' : param?.x_group_id
        };

        /*if(type == 'api' || type == 'api_v1' || type == 'aggregator_api' || type == 'pos_api' || type == 'delivery_api') {
            headers['X-Group-Id'] = param?.x_group_id;
        }*/


        const $api = axios.create({
            baseURL: url,
            headers: headers
        });

        $api.CancelToken = axios.CancelToken.source();
        return $api;
    } catch (e) {
        console.error('ERR_INIT_NODE:', type);
        console.error(e);
        return null;
    }
}
